import Button from '../Button/Button';
import { useAccessibility } from '../../context/AccessibilityContext/AccessibilityContext';
import style from './paginationcontrol.module.scss';

const PaginationControl = ({ page, setPage, pageCount }) => {
    const { settings: { contrast } } = useAccessibility();
    
    if (!pageCount || pageCount <= 1) return null;

    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= pageCount) {
            setPage(newPage);
        }
    };

    const renderPageNumbers = () => {
        const pages = [];
        const maxVisiblePages = 5;
        let startPage, endPage;

        if (pageCount <= maxVisiblePages) {
            startPage = 1;
            endPage = pageCount;
        } else {
            const maxPagesBeforeCurrent = Math.floor(maxVisiblePages / 2);
            const maxPagesAfterCurrent = Math.ceil(maxVisiblePages / 2) - 1;

            if (page <= maxPagesBeforeCurrent) {
                startPage = 1;
                endPage = maxVisiblePages;
            } else if (page + maxPagesAfterCurrent >= pageCount) {
                startPage = pageCount - maxVisiblePages + 1;
                endPage = pageCount;
            } else {
                startPage = page - maxPagesBeforeCurrent;
                endPage = page + maxPagesAfterCurrent;
            }
        }

        // Show first page and ellipsis if needed
        if (startPage > 1) {
            pages.push(
                <Button
                    key={1}
                    text="1"
                    onClick={() => handlePageChange(1)}
                    className={style.pageButton}
                    background="transparent"
                    color={contrast === 'default' ? '#1d3e8c' : 'var(--text-primary)'}
                />
            );
            if (startPage > 2) {
                pages.push(<span key="left-ellipsis" className={style.ellipsis}>...</span>);
            }
        }

        // Visible page numbers
        for (let i = startPage; i <= endPage; i++) {
            pages.push(
                <Button
                    key={i}
                    text={i.toString()}
                    onClick={() => handlePageChange(i)}
                    className={`${style.pageButton} ${page === i ? style.active : ''}`}
                    background={page === i ? 
                        (contrast === 'default' ? '#1d3e8c' : 'var(--accent-color)') : 
                        'transparent'}
                    color={page === i ? 
                        '#fff' : 
                        (contrast === 'default' ? '#1d3e8c' : 'var(--text-primary)')}
                    border={page === i ? 
                        'none' : 
                        `1px solid ${contrast === 'default' ? '#d9d9d9' : 'var(--text-primary)'}`}
                />
            );
        }

        // Show last page and ellipsis if needed
        if (endPage < pageCount) {
            if (endPage < pageCount - 1) {
                pages.push(<span key="right-ellipsis" className={style.ellipsis}>...</span>);
            }
            pages.push(
                <Button
                    key={pageCount}
                    text={pageCount.toString()}
                    onClick={() => handlePageChange(pageCount)}
                    className={style.pageButton}
                    background="transparent"
                    color={contrast === 'default' ? '#1d3e8c' : 'var(--text-primary)'}
                />
            );
        }

        return pages;
    };

    return (
        <div className={style.paginationContainer}>
            <Button
                text="Назад"
                onClick={() => handlePageChange(page - 1)}
                disabled={page === 1}
                className={style.navButton}
                background="transparent"
                color={contrast === 'default' ? '#1d3e8c' : 'var(--text-primary)'}
                iconLeft={<span className={style.arrow}>&lsaquo;</span>}
            />
            
            <div className={style.pagesWrapper}>
                {renderPageNumbers()}
            </div>

            <Button
                text="Вперед"
                onClick={() => handlePageChange(page + 1)}
                disabled={page === pageCount}
                className={style.navButton}
                background="transparent"
                color={contrast === 'default' ? '#1d3e8c' : 'var(--text-primary)'}
                iconRight={<span className={style.arrow}>&rsaquo;</span>}
            />
        </div>
    );
};

export default PaginationControl;